<template>
  <div class="main-options" :class="!hideMenuSeasonal ? 'option-gradient' : ''">
    <div class="desktop-filler"></div>
    <div class="navbar-select-row col">
      <NavOptions />
    </div>
    <div class="right-side-container col">
      <UIButton
        :key="$route.path"
        class="wrapper"
        color="green"
        height="30"
        size="14"
        shape="full"
        :extra-data="{ event: '' }"
        :to="$urlBuilder('plans-profile-redirect', { keyword: 'top-menu' })"
        @click="
          gaEvent(
            'Click Button Plans Index Menu',
            $urlBuilder('plans-profile-redirect', { keyword: 'top-menu' })
          )
        "
      >
        {{ $t('main.header.tags.pricing') }}
      </UIButton>
      <span class="menu-separator" />
      <UserSection class="wrapper user-section" />
    </div>
  </div>
</template>

<script>
import UIButton from 'UI/Button';
import UserSection from './UserSection';
import NavOptions from './NavOptions';

export default {
  components: {
    UIButton,
    UserSection,
    NavOptions
  },
  props: {
    hideMenuSeasonal: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    gaEvent(action, url) {
      this.$ga.event('Index Menu', action, this.$route.fullPath);
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.main-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 6px 2px 12px;
  @include lg {
    flex-direction: row-reverse;
  }
}
.navbar-select-row {
  display: flex;
  align-items: center;
  width: max-width;
  gap: 16px;
  justify-content: center;
  @include xl {
    display: none;
  }
}
.desktop-filler {
  width: 33%;
  visibilty: hidden;
  @include xl {
    display: none;
  }
}
.menu-separator {
  border-radius: 2px;
  margin-left: 16px;
  margin-right: 16px;
  height: 24px;
  width: 1px;
  background: $white;
}
.right-side-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  margin-left: 10px;
  margin-right: 10px;
  @include xl {
    margin-left: 2px;
    margin-right: 2px;
  }
}
.wrapper.plans-button {
  margin-right: 0;
}
</style>

<style lang="scss">
.option-gradient {
  background-color: transparent !important;
}
.seasonal-text {
  color: $white;
  @include xl2 {
    font-size: 18px !important;
  }
  @include lg {
    font-size: 13px !important;
  }
  @include md {
    display: none !important;
  }
}
</style>
